// extracted by mini-css-extract-plugin
module.exports = {"root":"TabContentProgress_root__YzVsE","label":"TabContentProgress_label__3A8Fj"};